import React, {createContext, useState} from "react";

const ALERT_TIME = 50000;
export const ERROR_TYPE = "Feil";
export const WARNING_TYPE = "Advarsel";
export const INFO_TYPE = "Info";
export const SUCCESS_TYPE = "Suksess";

const initState = {
    text:"",
    type:""
}

const AlertContext = createContext({
    ...initState,
    setAlert : () => {}
});


export const AlertProvider = ({children}) => {
    const [text, setText] = useState("");
    const [type, setType] = useState("");

    const setAlert = (type, text, time=ALERT_TIME, action=null) => {
        setText(text);
        setType(type);

        setTimeout(() => {
            setText("");
            setType("");

            if(action !== null){
                action();
            }

        }, time);
    };


    return (
        <AlertContext.Provider value={{
            text, type, setAlert,
        }}>
            {children}
        </AlertContext.Provider>
    )
}

export default AlertContext;